import { Group, Paper, Select, SelectItem, Text } from '@mantine/core'
import { forwardRef, useEffect, useState } from 'react'
import { SelectProps } from '@mantine/core/lib/Select/Select'
import Coordinator from '@api/Coordinator'

interface IInputCoordinator extends Omit<SelectProps & React.RefAttributes<HTMLInputElement>, 'data'> {
    data?: readonly (string | SelectItem)[]
    editMode?: boolean
}

interface ItemProps extends React.ComponentPropsWithoutRef<'div'> {
    value: string
    fullname: string
    email: string
    phone: string
    label: string
}

const InputCoordinator = ({
    editMode = true,
    classNames,
    value,
    styles,
    unstyled,
    className,
    defaultValue,
    ...others
}: IInputCoordinator) => {
    const { data } = Coordinator.useGetAllCoordinators({ limit: 1000 })
    const [list, setlist] = useState<ItemProps[]>([])
    useEffect(() => {
        if (data) {
            setlist(
                data.lists.map((e) => {
                    return {
                        value: String(e.coordinator_id),
                        fullname: e.coordinator_fullname,
                        email: e.coordinator_email,
                        phone: e.coordinator_phone,
                        label: e.coordinator_fullname,
                    }
                })
            )
        }
    }, [data])

    if (editMode === false) {
        const valueinput = list.filter((e) => e.value === String(value))
        if (valueinput.length) {
            return (
                <div>
                    <Text size='sm'>ผู้ประสานงาน</Text>
                    <Paper p='sm' withBorder mt='2px'>
                        <SelectItemComponent {...valueinput[0]} />
                    </Paper>
                </div>
            )
        }
    }
    return (
        <Select
            key={list.length}
            className={className}
            itemComponent={SelectItemComponent}
            label='ผู้ประสานงาน'
            value={String(value)}
            placeholder='ผู้ประสานงาน'
            searchable
            data={list}
            filter={(value, item: ItemProps) => item.fullname.toLowerCase().includes(value.toLowerCase().trim())}
            {...others}
        />
    )
}

export default InputCoordinator

const SelectItemComponent = forwardRef<HTMLDivElement, ItemProps>(
    ({ fullname, email, phone, label, ...others }: ItemProps, ref) => (
        <div ref={ref} {...others}>
            <Group noWrap>
                <div>
                    <Text size='sm'>{fullname}</Text>
                    {phone && <Text size='xs'>เบอร์โทร : {phone}</Text>}
                    {email && <Text size='xs'>อีเมล : {email}</Text>}
                </div>
            </Group>
        </div>
    )
)
